window.Blimp = window.Blimp || {};

class Report extends Backbone.Model {
  get idAttribute() {
    return 'public_id';
  }

  date() {
    return moment(this.get('taken_at') || this.get('created_at'));
  }

  parse(response, options) {
    this.user = new Blimp.User(response.user);
    this.groups = new Backbone.Collection(response.groups, { model: Blimp.Group });
    this.photos = new Backbone.Collection(response.photos, { model: Blimp.Photo });
    this.photos.each((p) => p.report = this);
    delete response.user;
    delete response.photos;
    delete response.groups;
    return response;
  }

  zip_url() {
    return `${this.url()}/zip`;
  }

  pdf_url() {
    return `${this.url()}/pdf`;
  }

  related_url() {
    return `${this.url()}/related`;
  }
}

Blimp.Report = Report;